// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-page-navigation {
  position: relative;
  width: 270px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #d0d0d0;
  z-index: 10;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}
.custom-page-navigation.collapsed {
  width: 48px;
}
.custom-page-navigation .page-nav-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}
.custom-page-navigation .page-nav-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s ease;
}
.custom-page-navigation .page-nav-header:hover {
  background: #f0f0f0;
}
.custom-page-navigation .page-nav-header i:first-child {
  color: #333;
  font-size: 0.9rem;
}
.custom-page-navigation .page-nav-header .page-nav-title {
  flex: 1 1;
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}
.custom-page-navigation .page-nav-header .page-nav-collapse-arrow {
  color: #666;
  font-size: 0.85rem;
}
.custom-page-navigation .page-nav-collapsed {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  background: #fafafa;
  transition: background 0.2s ease;
}
.custom-page-navigation .page-nav-collapsed:hover {
  background: #f0f0f0;
}
.custom-page-navigation .page-nav-collapsed .page-nav-expand-arrow {
  color: #666;
  font-size: 0.85rem;
  margin-bottom: 12px;
}
.custom-page-navigation .page-nav-collapsed .page-nav-vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  letter-spacing: 2px;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-page-navigation .page-nav-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
  background: #ffffff;
}
.custom-page-navigation .page-nav-list .page-nav-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}
.custom-page-navigation .page-nav-list .page-nav-item:hover {
  background: #f9f9f9;
}
.custom-page-navigation .page-nav-list .page-nav-item.active {
  background: #e8f4ff;
}
.custom-page-navigation .page-nav-list .page-nav-item.active .page-nav-item-text {
  color: #0078d4;
  font-weight: 600;
}
.custom-page-navigation .page-nav-list .page-nav-item.active .page-nav-check {
  color: #0078d4;
}
.custom-page-navigation .page-nav-list .page-nav-item .page-nav-item-text {
  flex: 1 1;
  font-size: 0.875rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-page-navigation .page-nav-list .page-nav-item .page-nav-check {
  font-size: 0.875rem;
  margin-left: 8px;
}
.custom-page-navigation .page-nav-list::-webkit-scrollbar {
  width: 8px;
}
.custom-page-navigation .page-nav-list::-webkit-scrollbar-track {
  background: #fafafa;
}
.custom-page-navigation .page-nav-list::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 4px;
}
.custom-page-navigation .page-nav-list::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}

@media (max-width: 768px) {
  .custom-page-navigation {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/CustomPageNavigation.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;AACJ;AAGE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gCAAA;AAFJ;AAII;EACE,mBAAA;AAFN;AAKI;EACE,WAAA;EACA,iBAAA;AAHN;AAMI;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAJN;AAOI;EACE,WAAA;EACA,kBAAA;AALN;AAUE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;AARJ;AAUI;EACE,mBAAA;AARN;AAWI;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AATN;AAYI;EACE,yBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVN;AAcE;EACE,SAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AAZJ;AAcI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,gCAAA;AAZN;AAcM;EACE,mBAAA;AAZR;AAeM;EACE,mBAAA;AAbR;AAeQ;EACE,cAAA;EACA,gBAAA;AAbV;AAgBQ;EACE,cAAA;AAdV;AAkBM;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBR;AAmBM;EACE,mBAAA;EACA,gBAAA;AAjBR;AAuBE;EACE,UAAA;AArBJ;AAwBE;EACE,mBAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,mBAAA;AAvBN;;AA6BA;EACE;IACE,wBAAA;EA1BF;AACF","sourcesContent":[".custom-page-navigation {\r\n  position: relative;\r\n  width: 270px;\r\n  height: 100%;\r\n  background: #ffffff;\r\n  border-right: 1px solid #d0d0d0;\r\n  z-index: 10;\r\n  transition: width 0.3s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);\r\n  flex-shrink: 0; // Don't shrink when in flex container\r\n\r\n  &.collapsed {\r\n    width: 48px;\r\n  }\r\n\r\n  // Expanded state - Full sidebar with pages\r\n  .page-nav-content {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    width: 100%;\r\n  }\r\n\r\n  .page-nav-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 12px 16px;\r\n    background: #fafafa;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    transition: background 0.2s ease;\r\n\r\n    &:hover {\r\n      background: #f0f0f0;\r\n    }\r\n\r\n    i:first-child {\r\n      color: #333;\r\n      font-size: 0.9rem;\r\n    }\r\n\r\n    .page-nav-title {\r\n      flex: 1;\r\n      font-size: 0.9rem;\r\n      font-weight: 600;\r\n      color: #333;\r\n    }\r\n\r\n    .page-nav-collapse-arrow {\r\n      color: #666;\r\n      font-size: 0.85rem;\r\n    }\r\n  }\r\n\r\n  // Collapsed state - Vertical text with arrow at top\r\n  .page-nav-collapsed {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 16px 0;\r\n    cursor: pointer;\r\n    background: #fafafa;\r\n    transition: background 0.2s ease;\r\n\r\n    &:hover {\r\n      background: #f0f0f0;\r\n    }\r\n\r\n    .page-nav-expand-arrow {\r\n      color: #666;\r\n      font-size: 0.85rem;\r\n      margin-bottom: 12px;\r\n    }\r\n\r\n    .page-nav-vertical-text {\r\n      writing-mode: vertical-rl;\r\n      text-orientation: mixed;\r\n      font-size: 0.9rem;\r\n      font-weight: 600;\r\n      color: #333;\r\n      letter-spacing: 2px;\r\n      flex: 1;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n  }\r\n\r\n  .page-nav-list {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 0;\r\n    background: #ffffff;\r\n\r\n    .page-nav-item {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      padding: 12px 16px;\r\n      cursor: pointer;\r\n      transition: background 0.2s ease;\r\n      border-bottom: 1px solid #f0f0f0;\r\n\r\n      &:hover {\r\n        background: #f9f9f9;\r\n      }\r\n\r\n      &.active {\r\n        background: #e8f4ff;\r\n\r\n        .page-nav-item-text {\r\n          color: #0078d4;\r\n          font-weight: 600;\r\n        }\r\n\r\n        .page-nav-check {\r\n          color: #0078d4;\r\n        }\r\n      }\r\n\r\n      .page-nav-item-text {\r\n        flex: 1;\r\n        font-size: 0.875rem;\r\n        color: #333;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n      }\r\n\r\n      .page-nav-check {\r\n        font-size: 0.875rem;\r\n        margin-left: 8px;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Scrollbar styling\r\n  .page-nav-list::-webkit-scrollbar {\r\n    width: 8px;\r\n  }\r\n\r\n  .page-nav-list::-webkit-scrollbar-track {\r\n    background: #fafafa;\r\n  }\r\n\r\n  .page-nav-list::-webkit-scrollbar-thumb {\r\n    background: #c0c0c0;\r\n    border-radius: 4px;\r\n\r\n    &:hover {\r\n      background: #a0a0a0;\r\n    }\r\n  }\r\n}\r\n\r\n// Hide on mobile - use the dropdown instead\r\n@media (max-width: 768px) {\r\n  .custom-page-navigation {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
